(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

module.exports = function () {
    var Facebook = {
        appId: '',
        language: 'EN',
        quickSign: {
            enabled: true,
            requiredFields: ['email', 'city', 'state']
        }
    };

    Facebook.init = function () {};

    $(function () {
        var socialFacebook = window.P2A.Social.Facebook;
        $(socialFacebook).on('userRetrieved', function (e, data) {
            var userInfo = $.extend(data.user, { authInfo: socialFacebook.authInfo });
            console.log(userInfo);
            var quickSign = Facebook.quickSign;
            var requiredFieldMissing = false;
            if (quickSign.enabled === true) {
                //If quick sign is enabled, make sure that we have data for all of the required fields (specifically for quick sign)
                var numRequiredFields = quickSign.requiredFields.length;
                var requiredField = null;
                for (var i = 0; i < numRequiredFields; i++) {
                    requiredField = quickSign.requiredFields[i];
                    if (!userInfo[requiredField] || !userInfo[requiredField].length) {
                        //We found at least one missing required field - break
                        requiredFieldMissing = true;
                        break;
                    }
                }
            }

            var $filledInFields = [];
            //Calculate the values that we will stick into the UI fields
            var fullName = '';
            if (userInfo.firstName && userInfo.lastName) {
                fullName += userInfo.firstName + ' ' + userInfo.lastName;
            } else if (userInfo.firstName) {
                fullName += userInfo.firstName;
            } else if (userInfo.lastName) {
                fullName += userInfo.lastName;
            }

            var prefix = '';
            if (userInfo.gender === 'male') {
                prefix = 'Mr.';
            } else if (userInfo.gender === 'female') {
                prefix = 'Ms.';
            }

            //Stick the values into the UI fields
            if (prefix) {
                var $prefix = $('#prefix');
                $prefix.val(prefix);
                $filledInFields.push($prefix);
            }

            if (fullName) {
                var $fullName = $('#fullname');
                $fullName.val(fullName);
                $filledInFields.push($fullName);
            }

            if (userInfo.email) {
                var $email = $('#email');
                $email.val(userInfo.email);
                $filledInFields.push($email);
            }

            //If quick sign is turned off (so pre-fill only), or we don't have all the required fields,
            //then save whatever info we have (including login), and fill in whatever fields we can
            //Otherwise we will pass all the data together in one request
            if (quickSign.enabled !== true || requiredFieldMissing === true) {
                socialFacebook.hideLoginButton();

                //Add the App ID to the auth info, since a user id is scoped to an app id
                userInfo.authInfo.appId = socialFacebook.appId;

                //If the user has an email, save the login info in the background
                //This is in case they never submit - we've still captured some info
                if (userInfo.email) {
                    var loginData = {};
                    loginData.advocateData = {
                        firstname: userInfo.firstName,
                        lastname: userInfo.lastName,
                        email: userInfo.email,
                        city: userInfo.city,
                        state: userInfo.state,
                        facebook: userInfo.authInfo
                    };
                    loginData.campaignInfo = window.P2A.CampaignData;
                    socialFacebook.SaveLogin(loginData);
                }

                socialFacebook.displayLoginStatus('Please fill in the remaining information to take action.');

                var numFilledInFields = $filledInFields.length;
                for (var i = 0; i < numFilledInFields; i++) {
                    var $filledInField = $($filledInFields[i]);
                    $filledInField.addClass('social-filled-in-facebook');

                    if ($filledInField.prop("tagName") !== 'SELECT' && $filledInField.attr('type') !== 'radio' && $filledInField.attr('type') !== 'checkbox') {
                        $filledInField.after('<span class="fa fa-facebook-official social-filled-in-facebook-icon"></span>');
                    }
                }

                //Set the focus to the first non-entered element
                var $nonFilledInFields = $('#action-container :input:visible').not('.social-filled-in-facebook, button, [type="checkbox"], [type="radio"]');
                $nonFilledInFields.first().focus();
            } else {
                //Quicksign
                //Hide all fields except submit button, add auth info, and submit
                var $actionForm = $('#take-action-form');
                $actionForm.children().slideUp(600);
                socialFacebook.hideLoginButton();

                //Show button as loading (do not disable yet, we still need to submit it)
                var $submitButton = $('#action-submit', $actionForm);
                $submitButton.width($submitButton.width() + 'px');
                $submitButton.html('<i class="fa fa-spin fa-spinner"></i>');

                //Stick in city and state if we have them
                if (userInfo.city) {
                    $('.action-city', $actionForm).val(userInfo.city);
                }
                if (userInfo.state) {
                    $('.action-state', $actionForm).val(userInfo.state);
                }

                //Create Facebook user info element and populate it
                var $userInfo = $('.action-social-facebook-user-info');
                if (!$userInfo || !$userInfo.length) {
                    //Create the element
                    $actionForm.prepend('<input type="hidden" name="social-facebook-user-info" value="" class="action-social-facebook-user-info">');
                    $userInfo = $('.action-social-facebook-user-info');
                }
                //Populate it
                $userInfo.val(JSON.stringify(userInfo.authInfo));

                //Now submit the form
                $submitButton.trigger('click');

                //And disable it so that it can't be submitted twice while loading
                $submitButton.prop('disabled', true);
            }
        });
    });

    return Facebook;
};

},{}],2:[function(require,module,exports){
"use strict";

var Facebook = require('./_facebook')();

if (!window.P2A) {
    window.P2A = {};
}
window.P2A.Petition = {
    "Facebook": Facebook
};

},{"./_facebook":1}]},{},[2]);
